import { Component } from 'vue';

import {
    getFormElementComponentFromComponentsMap,
} from '@evidentid/dashboard-commons/components/EidJsonSchemaForm/formElementComponent';
import {
    EidJsonSchemaFormComponentMatchingFunction,
    EidJsonSchemaFormCustomComponentsMap,
} from '@evidentid/dashboard-commons/components/EidJsonSchemaForm/types';
import JsonSchema, { JsonSchemaEnum, JsonSchemaType } from '@evidentid/json-schema/interfaces/JsonSchema';
import { TprmSchemaDisplayFormat } from '@evidentid/tprm-portal-lib/models/common/TprmSchemaDisplayFormat.model';

import CriterionBooleanInput from './CriterionBooleanInput.vue';
import CriterionCheckboxInput from './CriterionCheckboxInput.vue';
import CriterionCurrencyInput from './CriterionCurrencyInput.vue';
import CriterionEnumCountryInput from './CriterionEnumCountryInput.vue';
import CriterionEnumInput from './CriterionEnumInput.vue';
import CriterionObjectInput from './CriterionObjectInput.vue';
import CriterionTextInput from './CriterionTextInput.vue';

// PRODUCT-26110 Phase 2B2: `EidJsonSchemaFormCustomComponentsMap` (dashboard-commons)
// is still typed against vue-property-decorator's `Vue.Component`/`Vue.AsyncComponent`
// ambient globals, which resolve to vue@2-shaped types in this program (see
// .superpowers/sdd/b2-findings.md, "vuex/Vue.Component ambient shim" entry) — a
// dashboard-commons-owned type, out of this batch's scope. Build the map against
// vue 3's own `Component` type, which is what these .vue components actually are, and
// cast at the dashboard-commons call boundary below.
const componentsMap: Record<string, Component> = {
    [TprmSchemaDisplayFormat.currency]: CriterionCurrencyInput,
    [TprmSchemaDisplayFormat.checkbox]: CriterionCheckboxInput,
    [TprmSchemaDisplayFormat.country]: CriterionEnumCountryInput,
    [TprmSchemaDisplayFormat.insuredField]: CriterionEnumInput,
    [JsonSchemaType.boolean]: CriterionBooleanInput,
    [JsonSchemaType.object]: CriterionObjectInput,
    [JsonSchemaType.string]: CriterionTextInput,
};

export const criterionJsonSchemaFormElementsMap =
    componentsMap as unknown as EidJsonSchemaFormCustomComponentsMap;

function isJsonSchemaEnum(schema: JsonSchema): schema is JsonSchemaEnum {
    return (schema as any).type === JsonSchemaType.string && (schema as any).enum && (schema as any).enumLabels;
}

export const getJsonSchemaCustomComponentInput: EidJsonSchemaFormComponentMatchingFunction = ({ schema }) => {
    if (isJsonSchemaEnum(schema)) {
        return CriterionEnumInput as unknown as ReturnType<EidJsonSchemaFormComponentMatchingFunction>;
    }
    return getFormElementComponentFromComponentsMap({ componentsMap: criterionJsonSchemaFormElementsMap, schema });
};
